const userStatusList = [
  { label: 'Yes', value: 'Active' },
  { label: 'No', value: 'Inactive' },
];

const investmentStatusList = [
  { label: 'Invested', value: 'Invested' },
  { label: 'Not Invested', value: 'Not Invested' },
];

const regulationStatusList = [
  { label: 'Approved', value: 'Approved' },
  { label: 'Not Approved', value: 'Not Approved' },
  { label: 'Pending', value: 'Pending' },
  { label: 'Not Requested', value: 'Not Requested' },
]

const duplicateUsersFilterList = [
  {label: 'Phone Number', value: 'phoneNumber'},
  {label: 'SSN', value: 'encodedSSN'},
]

const DWOLLA_CUSTOMER_STATUS = {
  VERIFIED: 'verified',
  SUSPENDED: 'suspended',
  RETRY: 'retry',
  DOCUMENT: 'document',
}

const DWOLLA_CUSTOMER_STATUS_COLOR = {
  'verified': 'success',
  'suspended': 'error',
  'retry': 'warning',
  'document': 'warning',
}

export { DWOLLA_CUSTOMER_STATUS, DWOLLA_CUSTOMER_STATUS_COLOR, investmentStatusList, regulationStatusList, userStatusList, duplicateUsersFilterList };

